module.exports = __webpack_public_path__ + "static/media/quansh_2x.6cdc4a73.svg";